/* @ngInject */
export default function nvFileUploadProgress() {
  return {
    scope: {
      autoEnrollment: '=',
    },
    templateUrl: 'shared/templates/nv-user-management-description-accordion.html',
  };
}
